import { objectfyArray } from "../helpers/objectfyArray";

import { cloneDeep } from "lodash";

const createTempId = (length) => {
  var result = "";
  var characters = "0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

const store = (state = {}, action) => {
  Object.freeze(state);
  let newState;
  switch (action.type) {
    case "SET_STORE_ITEMS":
      if (Array.isArray(action.storeItems)) {
        return objectfyArray(action.storeItems);
      } else {
        return action.storeItems;
      }

    case "SET_STORE_ITEM":
      return {
        ...state,
        [action.storeItem.id]: action.storeItem,
      };
    case "REMOVE_STORES":
      return {};
    case "REMOVE_STORE":
      newState = {
        ...state,
      };
      delete newState[action.storeItem.id];
      return newState;
    case "ADD_TEMP_STORE_ITEM":
      return {
        ...state,
        newStoreItem: {
          id: "newStoreItem",
          price: null,
          finePrint: "",
          maxPurchasesTotal: null,
          maxPurchasesPerUser: null,
          usePurchasedItemsBy: null,
          imageUrl: null,
          title: "",
          description: "",
          expiration: null,
          importantNote: "",
          isLive: true,
          isPublic: true,
          additionalOptions: [],
        },
      };
    case "ADD_TEMP_STORE_CLONE_ITEM":
      let clone = cloneDeep(action.storeItem);
      let tempId = 1;
      if (clone.additionalOptions.length > 0) {
        clone.additionalOptions.forEach((group) => {
          delete group.purchaseItem;
          delete group.id;
          if (group.minOptions === null) {
            group.minOptions = -1;
          }
          group.id = createTempId(20);
          if (group.additionalOptionsItems.length > 0) {
            group.additionalOptionsItems.forEach((option) => {
              delete option.additionalOptionsGroupId;
              delete option.id;
              option.id = tempId;
              tempId += 1;
            });
          }
        });
      }

      return {
        ...state,
        newStoreItem: {
          id: "newStoreItem",
          price: action.storeItem.price,
          finePrint: action.storeItem.finePrint,
          maxPurchasesTotal: action.storeItem.maxPurchasesTotal,
          maxPurchasesPerUser: action.storeItem.maxPurchasesPerUser,
          usePurchasedItemsBy: null,
          imageUrl: action.storeItem.imageUrl,
          title: action.storeItem.title,
          description: action.storeItem.description,
          expiration: null,
          importantNote: action.storeItem.importantNote,
          isLive: action.storeItem.isLive,
          isPublic: action.storeItem.isPublic,
          numberOfTotalPurchases: 0,
          additionalOptions: clone.additionalOptions,
          templateId: clone.templateId,
        },
      };
    case "UPDATE_TEMP_STORE_ITEM":
      newState = {
        ...state,
      };
      delete newState.newStoreItem;
      return {
        ...newState,
        [action.storeItem.id]: action.storeItem,
      };
    case "DELETE_TEMP_STORE_ITEM":
      newState = {
        ...state,
      };
      delete newState.newStoreItem;
      return {
        ...newState,
      };
    case "UPDATE_STORE_ITEM":
      newState = {
        ...state,
      };
      newState[action.storeItem.id] = action.storeItem;
      return newState;
    default:
      return state;
  }
};

export default store;
